// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scl--conic-com-spotlight {
  position: relative;
  width: 40%;
  height: 100vh;
  max-height: 1212px;

  background: conic-gradient(
    from 270deg at 0% 50%,
    #CE7D63 -17.29deg,
    #E9F3FF 0.14deg,
    rgba(206, 125, 99, 0.5) 18.03deg,
    #000000 53.94deg,
    rgba(0, 0, 0, 0.75) 152.86deg,
    rgba(106, 106, 106, 0.854002) 164.1deg,
    rgba(255, 255, 255, 0.9) 179.57deg,
    #FFFFFF 179.87deg,
    rgba(255, 255, 255, 0.9) 180.27deg,
    rgba(0, 0, 0, 0.75) 207.21deg,
    #000000 304.57deg,
    #CE7D63 342.71deg,
    #E9F3FF 360.14deg
  );

  overflow: hidden;
}

/* Beam breathing mask */
.scl--conic-com-spotlight::after {
  content: "";
  position: absolute;
  inset: 0;
  background: inherit;
  transform-origin: left center;
  animation: beamZoom 3s ease-in-out infinite;
  opacity: 0.85;
}

@keyframes beamZoom {
  0%, 100% {
    transform: scaleY(0.92);
  }
  50% {
    transform: scaleY(1.05);
  }
}
`, "",{"version":3,"sources":["webpack://./src/page-module/page-services/company/css/conicComSpotlight.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,kBAAkB;;EAElB;;;;;;;;;;;;;;;GAeC;;EAED,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB,6BAA6B;EAC7B,2CAA2C;EAC3C,aAAa;AACf;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;AACF","sourcesContent":[".scl--conic-com-spotlight {\n  position: relative;\n  width: 40%;\n  height: 100vh;\n  max-height: 1212px;\n\n  background: conic-gradient(\n    from 270deg at 0% 50%,\n    #CE7D63 -17.29deg,\n    #E9F3FF 0.14deg,\n    rgba(206, 125, 99, 0.5) 18.03deg,\n    #000000 53.94deg,\n    rgba(0, 0, 0, 0.75) 152.86deg,\n    rgba(106, 106, 106, 0.854002) 164.1deg,\n    rgba(255, 255, 255, 0.9) 179.57deg,\n    #FFFFFF 179.87deg,\n    rgba(255, 255, 255, 0.9) 180.27deg,\n    rgba(0, 0, 0, 0.75) 207.21deg,\n    #000000 304.57deg,\n    #CE7D63 342.71deg,\n    #E9F3FF 360.14deg\n  );\n\n  overflow: hidden;\n}\n\n/* Beam breathing mask */\n.scl--conic-com-spotlight::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: inherit;\n  transform-origin: left center;\n  animation: beamZoom 3s ease-in-out infinite;\n  opacity: 0.85;\n}\n\n@keyframes beamZoom {\n  0%, 100% {\n    transform: scaleY(0.92);\n  }\n  50% {\n    transform: scaleY(1.05);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
